var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0316 0H7.96837C7.6716 0 7.39015 0.131823 7.20015 0.359816L5.29985 2.64018C5.10985 2.86818 4.8284 3 4.53163 3H2H1C0.447715 3 0 3.44772 0 4V5V14V15C0 15.5523 0.447715 16 1 16H2H18H19C19.5523 16 20 15.5523 20 15V14V5V4C20 3.44772 19.5523 3 19 3H18H15.4684C15.1716 3 14.8901 2.86818 14.7002 2.64018L12.7998 0.359815C12.6099 0.131823 12.3284 0 12.0316 0ZM13 9C13 10.6569 11.6569 12 10 12C8.34315 12 7 10.6569 7 9C7 7.34315 8.34315 6 10 6C11.6569 6 13 7.34315 13 9Z",
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPurple);
export default __webpack_public_path__ + "static/media/camera_purple.e4643e122b48b4a9e4ec8cbb29fe84fa.svg";
export { ForwardRef as ReactComponent };